import { FieldOperationsModel } from '../models/FieldOperationsModel';
import { Position } from '@turf/helpers';
import { defineStore } from 'pinia';

export const useFieldStore = defineStore('fields', {
  // arrow function recommended for full type inference
  state: () => ({
    fieldArea: 9,
    fields: [] as Array<FieldOperationsModel>,
    field: null as FieldOperationsModel | null,
    editMode: false,
    addMode: false,
    clearFieldMap: false,
    currentPolygon: [[]] as Position[][],
    revertBoundary: false
  }),
  getters: {
    availableFields(): Array<FieldOperationsModel> {
      return this.fields;
    },
    selectedField(): FieldOperationsModel | null {
      return this.field;
    },
    editFieldMode(): boolean {
      return this.editMode;
    },
    addFieldMode(): boolean {
      return this.addMode;
    },
    selectedFieldArea(): number {
      return this.fieldArea;
    },
    polygon(): Position[][] {
      return this.currentPolygon;
    }
  },
  actions: {
    setFields(fields: FieldOperationsModel[]) {
      this.fields = fields;
    },
    setSelectedField(field: FieldOperationsModel) {
      this.field = field;
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
    },
    toggleAddMode() {
      this.addMode = !this.addMode;
    },
    setSelectedFieldArea(area: number) {
      this.fieldArea = Math.round(area);
    },
    triggerClearFieldMap() {
      this.clearFieldMap = !this.clearFieldMap;
    },
    updateCurrentPolygon(polygon: Position[][]) {
      this.currentPolygon = polygon;
    },
    triggerRevertBoundary() {
      this.revertBoundary = !this.revertBoundary;
    }
  },
  persist: true
});
